// @flow
import * as React from 'react';
import { AlertItem } from './alert-item';
import { useNavigate } from 'react-router-dom';
import { useOutdatedFollowUps } from '../../../../../hooks/use-outdated-follow-ups';

type Props = {
  agentId?: string
};
export const OutdatedFollowUpAlert = ({agentId}: Props) => {
  const outdated = useOutdatedFollowUps(agentId)
  const outdatedLength =  outdated?.length;
  const navigate = useNavigate();

  if (!outdatedLength) return null;

  return (
    <AlertItem variant={'filled'} onClick={() => {navigate(`/dashboard/outdated-follow-ups/${agentId}`)}}>
      You have {outdatedLength} Follow Up that are dates prior to today's date. Please review the disposition and Next Contact Date.
    </AlertItem>
  );
};
